// extracted by mini-css-extract-plugin
module.exports = {"videosSection":"styles_videosSection___cFDP","videoWrapper":"styles_videoWrapper__hgYa0","video":"styles_video__Lzexr"};